export default __webpack_public_path__ + "00a01a089b1f4cfa68313d4d55189720.png";